// Collapses runs of consecutive serial numbers into FIRST..LAST, the same form
// the backend accepts when serials are entered:
//   ["AB0001", "AB0002", "AB0003", "AB0007"] -> ["AB0001..AB0003", "AB0007"]
// Serials only count as consecutive when they share everything but their
// trailing digits, and those have the same width.

function splitNumber(serial) {
  const match = /^(.*?)(\d+)$/.exec(serial);
  if (!match) return null;
  return {prefix: match[1], number: parseInt(match[2], 10), width: match[2].length};
}

function follows(previous, next) {
  const a = splitNumber(previous);
  const b = splitNumber(next);
  return !!(a && b && a.prefix === b.prefix && a.width === b.width && b.number === a.number + 1);
}

export function compactSerials(serials) {
  const sorted = [...(serials || [])].sort();
  const runs = [];

  sorted.forEach((serial) => {
    const run = runs[runs.length - 1];
    if (run && follows(run.last, serial)) {
      run.last = serial;
    } else {
      runs.push({first: serial, last: serial});
    }
  });

  return runs.map((run) => run.first === run.last ? run.first : `${run.first}..${run.last}`);
}
